import core, { App } from '@gin-betting/core';

import { LocalRouts } from 'app-constants';

const {
    utils: { isOneOfPages },
} = core;

export const layoutChanger = (): void => {
    const layoutElement: HTMLElement | null = document.querySelector('.layout');

    if (layoutElement) {
        layoutElement.style.overflow = 'initial';
        layoutElement.style.minWidth = 'initial';
    }

    const ineptWr = document.querySelector('.content-container-wrap');
    const ineptWr1 = document.querySelector(
        '.content-container-wrap .betting__wrapper'
    );

    if (ineptWr) {
        ineptWr.className = '';
    }

    if (ineptWr1) {
        ineptWr1.className = '';
    }
};

export const checkIsBannerCarouselPage = (): boolean =>
    isOneOfPages(
        [App.Routes.UPCOMING_LIST, App.Routes.ESPORT, App.Routes.CLASSIC],
        { exact: true }
    ) ||
    isOneOfPages([
        App.Routes.LIVE_LIST,
        App.Routes.RESULTS_LIST,
        App.Routes.PREMATCH,
        (LocalRouts.FAVORITE_UPCOMING as unknown) as App.Routes,
        (LocalRouts.FAVORITE_OUTRIGHTS as unknown) as App.Routes,
        (LocalRouts.FAVORITE_RESULTS as unknown) as App.Routes,
    ]);
